import React, { Component } from 'react'
import { connect } from 'react-redux'
import Cleave from 'cleave.js/react'

import setActiveCreditType from '../../../../actions/activeCreditTypeActions'

class CreditCardField extends Component {
	constructor(props, context) {
		super(props, context)

		this.state = {
			creditCardCleave: null,
			creditCardType: ''
		}

		this.onCreditCardTypeChanged = this.onCreditCardTypeChanged.bind(this)
		this.onCreditCardInit = this.onCreditCardInit.bind(this)
	}

	onCreditCardTypeChanged(type) {
		const { updateCardType } = this.props
		this.setState({creditCardType: type})
		updateCardType(type)
	}

	onCreditCardInit(cleave) {
		this.setState({creditCardCleave: cleave})
	}

	render() {
		const { configData, input, label, meta: { valid, touched, error } } = this.props
		const hotelLabels = configData.hotel.labels[0]

		return (
			<div className={
				touched && error ?
					'u-form-col u-form-col--error'
				: touched && valid ?
					'u-form-col u-form-col--valid u-form-col--'
				:
					'u-form-col'
			}>
			<label id={ input.name + 'Label' } className="u-form-label" htmlFor={ input.name }>*{ label }</label>
			<div className="bk-flow-payment__card-number">
				<Cleave
					{...input}
					aria-labelledby={ input.name + 'Label' }
					options={{
						creditCard: true,
						onCreditCardTypeChanged: this.onCreditCardTypeChanged
					}}
				/>

				{ hotelLabels.noDashSpace &&
					<p className="u-form-sublabel--bottom u-font-small">{ hotelLabels.noDashSpace ? hotelLabels.noDashSpace : 'No dashes or spaces' }</p>
				}

				<div className={ 'bk-flow-payment__card-type bk-flow-payment__card-type--' + this.state.creditCardType }>{ 'u-card-type u-card-type--' + this.state.creditCardType }</div>
			</div>

			{ touched && ((error && <p className="u-font-error">{error}</p>)) }
		</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		configData: state.configData.configuration
	}
}

const mapDispatchToProps = dispatch => ({
	updateCardType(cardType) {
		return (
			dispatch(setActiveCreditType(cardType))
		)
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(CreditCardField)


// WEBPACK FOOTER //
// ./src/components/forms/creditCardForm/elements/CreditCardField.js